<template>
  <div class="container">
    <!-- <router-link to="/" class="logo"></router-link> -->
    <a href="/" class="logo"></a>
    <div class="menu" ref="menu">
      <ul class="ieWhidth" ref="ulw">
        <li
          @click="staticClick('/anti-fraud/')"
          class="download_prompt"
          style="color:red"
        >
          反诈举报
        </li>
        <li @click="staticClick('/xiazai/')" class="software_download">
          <span>软件下载</span>
        </li>
        <li @click="staticClick('/buy/')" class="download_prompt">
          <span>套餐购买</span>
        </li>
        <li @click="staticClick('/help.html')"><span>使用教程</span></li>
        <li class="more-products-mobile" @click="openHttp">
          <span>HTTP代理</span>
        </li>
        <li class="activity-column">
          <span
            >活动专栏<img
              src="/static/image/public/arrow-bottom.png"
              width="12"
              height="12"
          /></span>
          <div class="activity-box">
            <ul>
              <li class="text">活动、优惠专栏</li>
              <li
                @click="openActivity('/help/371645.html')"
                class="online-discount"
              ></li>
              <li
                @click="openActivity('/help/562917.html')"
                class="exclusive-discount"
              ></li>
              <li
                @click="openActivity('/help/874531.html')"
                class="positive-feedback-vip"
              ></li>
              <li
                @click="openActivity('/attract/')"
                class="invite-friends"
              ></li>
            </ul>
          </div>
        </li>
        <li class="more-products">
          <span
            >HTTP代理<img
              src="../../assets/img/arrow-bottom.png"
              width="12"
              height="12"
          /></span>
          <div class="other-ip-agent">
            <ul>
              <li class="text">更多IP代理</li>
              <li class="jc-product" @click="openQiye"></li>
              <li class="ip-product" @click="openHttp"></li>
              <li class="text">其他软件</li>
              <li class="jump-mapping" @click="openFly2cn"></li>
              <li class="overseas-ip" @click="openOverseasIp"></li>
            </ul>
          </div>
        </li>
        <li class="personal-center personal-center1" v-if="userPhone">
          <img src="../../assets/img/tiaozhuansmallimg.png" />
          <span> {{ userPhone }}</span>
        </li>
        <li v-if="!userPhone" class="login-btn">
          <button><a href="/resource/login/">登录</a></button>
        </li>
        <li v-if="!userPhone" class="register-btn">
          <button><a href="/zhuce/?channel=tiaozhuan">注册</a></button>
        </li>
        <!-- <li v-if="!isLogin" @click="staticClick('/resource/login/')">个人中心</li>
                <li  v-if="isLogin==true">
                    <router-link class="color_one" type="info" to="/Personal">个人中心</router-link>
                </li>
                <li v-if="!isLogin">
                    <span @click="staticClick('/zhuce/?channel=tiaozhuan')">免费试用</span>
                </li> -->
      </ul>
    </div>
    <div class="MobileBar" @click="handleclick" ref="MobileBar">
      <span></span>
      <span></span>
      <span></span>
    </div>
    <moblie-menu :show="show" @clickmenu="clickmenu"></moblie-menu>
    <!-- <Mobile></Mobile> -->
  </div>
</template>

<script>
import Cookies from "js-cookie";
import MoblieMenu from "./components/MoblieMenu";
import Mobile from "./components/Mobile";
export default {
  name: "Header",
  components: { MoblieMenu, Mobile },
  data() {
    return {
      isLogin: "",
      show: false,
      myself: this.$store.state.LoginStatus,
      menuList: [
        {
          title: "首页",
          path: "/"
        },
        {
          title: "使用教程",
          path: "/Tutorial"
        },
        {
          title: "软件下载",
          path: "/Download"
        },
        {
          title: "套餐购买",
          path: "/Buy"
        }
      ],
      userPhone: "",
      width700: true
    };
  },
  computed: {
    status() {
      if (this.$store.state.LoginStatus) {
        return "active";
      } else {
        return;
      }
    }
  },
  methods: {
    staticClick(url) {
      window.location.href = url;
    },
    openHttp() {
      window.open("https://ip.huashengdaili.com/");
    },
    openQiye() {
      window.open("https://qiye.huashengdaili.com/");
    },
    openFly2cn() {
      window.open("https://www.huashengproxy.com/");
    },
    openOverseasIp() {
      window.open("https://www.jishidaili.com/");
    },
    openActivity(link) {
      window.open(link);
    },
    Fix__BUG() {
      //特别说明 此方法与 个人中心 子组件相关 修复其状态未恢复问题
      this.$store.commit("changeSub", false);
    },
    handleclick(e) {
      if (!e) {
        this.$refs.MobileBar.classList.remove("active");
        this.show = false;
        return;
      }
      if (this.$refs.MobileBar.classList.contains("active")) {
        this.$refs.MobileBar.classList.remove("active");
        this.show = false;
      } else {
        this.$refs.MobileBar.classList.add("active");
        this.show = true;
      }
    },
    clickmenu(show) {
      this.handleclick(show);
    },
    changeLogin() {
      //退出时将从缓存中移除 用户session 登录状态LoginStatus
      // localStorage.removeItem("session")
      // localStorage.removeItem("user_name")
      this.$store.commit("changeLogin", false);
      localStorage.removeItem("LoginStatus");
      Cookies.remove("session");
      Cookies.remove("username");
      this.$router.push("/");
      // Vue路由特性
      const num = Math.random().toString();
      Cookies.set("session", num);
    },
    getExplorer() {
      var explorer = window.navigator.userAgent,
        compare = function(s) {
          return explorer.indexOf(s) >= 0;
        },
        ie11 = (function() {
          return "ActiveXObject" in window;
        })();
      if (compare("MSIE") || ie11) {
        return "ie";
      } else if (compare("Firefox") && !ie11) {
        return "Firefox";
      } else if (compare("Chrome") && !ie11) {
        if (explorer.indexOf("Edge") > -1) {
          return "Edge";
        } else {
          return "Chrome";
        }
      } else if (compare("Opera") && !ie11) {
        return "Opera";
      } else if (compare("Safari") && !ie11) {
        return "Safari";
      }
    }
  },
  created() {
    this.$nextTick(function() {
      if (this.getExplorer() != "ie") {
        this.$refs["ulw"].classList.remove("ieWhidth");
      }
    });
    let session_s = localStorage.getItem("session");
    let user_phone = localStorage.getItem("username");
    if (session_s && user_phone) {
      this.userPhone = user_phone;
    }

    // Vue路由特性
    const num = Math.random().toString();
    Cookies.set("session", num);

    //2020-7-17
    if (localStorage.getItem("username")) {
      this.isLogin = true;
    } else {
      this.isLogin = false;
    }
  },
  mounted() {
    let menuList = this.$refs.menu.getElementsByTagName("li");
    for (let i = 0; i < menuList.length; i++) {
      menuList[i].addEventListener("click", function() {
        for (let j = 0; j < menuList.length; j++) {
          menuList[j].style.color = "#ffffff";
        }
        this.style.color = "#21a07d";
      });
    }
    //用户登录后关闭了浏览器 二次登录时 导航栏使用了Vuex管理状态 所以必须 进行恢复
    let session = Cookies.get("session");
    if (!session) {
      this.changeLogin();
    }
  }
};
</script>

<style lang="stylus" scoped>
// 更多产品start
.more-products-mobile
    display none
.more-products,.activity-column
    position relative

.more-products span img,.activity-column span img
    transition all .5s
    margin-left 5px

.more-products:hover span img,.activity-column:hover span img
    transform: rotate(180deg)
.activity-column:hover::after,.activity-column:hover::before
  display none

.more-products:hover .other-ip-agent,.activity-column:hover .activity-box
    display: block

.more-products .other-ip-agent,.activity-column .activity-box
    display none
    background-color #fff
    position absolute
    padding 20px
    box-sizing border-box
    z-index 9999
    top 52px
    line-height 1
    right 0;
    border-radius 10px
    transition all .5s
    width 310px !important

    box-shadow 0px 0.7px 5.4px -3px rgba(0, 0, 0, 0.077),0px 2px 21px -3px rgba(0, 0, 0, 0.13)

.activity-column .activity-box
  left 0

.more-products .other-ip-agent ul
   display block

.more-products .other-ip-agent ul li.text,.activity-column .activity-box ul li.text
  font-size 16px
  font-weight 700
  letter-spacing 1px
  color #000 !important
  line-height 1
  height auto !important
  text-align left


.more-products .other-ip-agent ul li.text
  margin-top 25px


.more-products .other-ip-agent ul li:not(.text)
  width 270px
  height 90px
  margin-top 15px
  border-radius 4px
  cursor pointer


.more-products .other-ip-agent ul li.jc-product
  background url('~@/assets/img/jcb270.png') no-repeat


.more-products .other-ip-agent ul li.ip-product
  background url('~@/assets/img/http270.png') no-repeat

.more-products .other-ip-agent ul li.jump-mapping
  background url('~@/assets/img/hwhttp270.png') no-repeat

.more-products .other-ip-agent ul li.overseas-ip 
  background: url('~@/assets/img/hwmobile270.png') no-repeat
  
.activity-column .activity-box ul li
  width 280px
  height 90px
  margin-top 15px
  border-radius 4px
  cursor pointer

.activity-column .activity-box ul li.online-discount
  background url('~@/assets/img/online-discount.png') no-repeat

.activity-column .activity-box ul li.exclusive-discount
  background url('~@/assets/img/exclusive-discount.png') no-repeat

.activity-column .activity-box ul li.positive-feedback-vip
  background url('~@/assets/img/positive-feedback-vip.png') no-repeat

.activity-column .activity-box ul li.invite-friends
  background url('~@/assets/img/invite-friends.png') no-repeat

/* 软件下载提示语 */
li.software_download
  position relative

li.software_download::after
  pointer-events none
  content '下载领10-30元优惠券'
  color #fff
  font-weight bold
  width 160px
  letter-spacing 1px
  height 30px
  line-height 30px
  position absolute
  z-index 2000
  left 50% !important
  transform translate(-50%, 0)
  bottom -21px
  font-size 13px
  letter-spacing 1px
  text-align center
  background-color #ff0000
  border-radius 5px
  background-size 100% 100%
  cursor pointer
  top 60px !important


li.software_download::before
  pointer-events none
  content ''
  width 0
  height 0
  border 8px solid
  border-color transparent transparent #ff0000 transparent
  position absolute
  top 45px
  z-index 2000
  right 48px !important

/* 软件下载提示语 end*/

/* 活动专栏 提示 start */
li.activity-column
  position relative

li.activity-column::after
  display none
  content '关注！每日最新活动~'
  color #fff
  font-weight bold
  width 170px
  letter-spacing 1px
  height 30px
  line-height 30px
  position absolute
  z-index 2000
  left 50% !important
  transform translate(-50%, 0)
  bottom -21px
  font-size 13px
  letter-spacing 1px
  text-align center
  background-color #ff0000
  border-radius 5px
  background-size 100% 100%
  cursor pointer
  top 60px !important

li.activity-column::before
  display none
  content ''
  width 0
  height 0
  border 8px solid
  border-color transparent transparent #ff0000 transparent
  position absolute
  top 45px
  z-index 2000
  right 48px !important
/* 活动专栏 提示 end */

// 更多产品end
.personal-center
    display flex
    align-items center
    text-align left !important
    img
        width 25px
        height 25px
        margin-right 5px
.login-btn button,.register-btn button
    width 70px
    height 30px
    border-radius 8px
    letter-spacing 2px
    a
        color #000
.container
    position relative
    height 100%
    width 1200px
    margin 0 auto
.logo
    height 100%
    width 2.8rem
    display inline-block
    // left 50%
    // transform translate(-50%, 0px)
    padding 0px 0px
    // background url('~@/assets/img/logowithtext.svg')
    background url('~@/assets/img/top_logo.png')
    background-repeat no-repeat
    background-position center
.menu
    // width 55%
    display inline-block
    position absolute
    right 0%
.menu .ieWhidth
    width 700px
.menu>ul
    display flex
.menu ul li
    flex 1
    color #fff
    text-align center
    cursor pointer
    line-height 70px
    width 110px
    font-size: 16px;
    font-weight: 600;

    &:hover
        color #21a07d
.menu ul li.attract
    color transparent
    line-height 70px
    position relative
    &::after
        display none
        content ''
        width 105px
        height 53px
        position absolute
        top 8px
        left 0
        background url('~@/assets/img/5-star-high-praise.gif') no-repeat center top
        @media (max-width:1100px)
            width 90px
    &:hover
        color transparent
.menu ul li.download_prompt
    position relative
.menu ul li.download_prompt span::after
    display none
    content "最高立减121元"
    color #fff
    font-weight bold
    width 105px
    letter-spacing 1px
    height 20px
    line-height 20px
    position absolute
    z-index 2000
    font-size 12px
    letter-spacing 1px
    text-align center
    background-color #ff0000
    border-radius 5px
    background-size 100% 100%
    cursor pointer
    z-index: 2000
    right 0px !important
    bottom -11px
@media (max-width:1200px)
    .more-products-mobile
        display block

    .more-products
        display none

    .menu ul li.download_prompt span::after,.menu ul li.download_prompt span::before
        display none
.menu ul li.download_prompt span::before
    display none
    content ''
    width 0
    height 0
    border 8px solid
    border-color transparent transparent #ff0000 transparent
    position absolute
    top 45px
    z-index 2000
    right 47px !important
.login_btn:hover span
    color #21a07d
 .color_one
    // border 2px solid #f5f7f9
    padding 4px 15px
    color  #f5f7f9
    border-radius 20px
.color_two
    border 2px solid #21a07d
    padding 4px 15px
    color  #21a07d
    border-radius 20px
.active
    span
        opacity 1
        -webkit-transform rotate(45deg)
        transform rotate(45deg)

    span:nth-last-child(3)
        opacity 1
        -webkit-transform rotate(-45deg);
        transform rotate(-45deg);

    span:nth-last-child(2)
        opacity 0
.MobileBar
    position absolute
    display none
    top 50%
    left 15px
    transform translate(0,-50%)
    span
        margin-left auto
        margin-right auto
        display block
        width 20px
        height 1px
        margin-bottom 6px
        position relative
        background #fff
        border-radius 3px
        z-index 1
        -webkit-transform-origin 20px
        transform-origin 20px
        -webkit-transition background 0.5s cubic-bezier(0.77, 0.2, 0.05, 1), opacity 0.55s ease, -webkit-transform 0.5s cubic-bezier(0.77, 0.2, 0.05, 1)
        transition background 0.5s cubic-bezier(0.77, 0.2, 0.05, 1), opacity 0.55s ease, -webkit-transform 0.5s cubic-bezier(0.77, 0.2, 0.05, 1)
        transition transform 0.5s cubic-bezier(0.77, 0.2, 0.05, 1), background 0.5s cubic-bezier(0.77, 0.2, 0.05, 1), opacity 0.55s ease
        transition transform 0.5s cubic-bezier(0.77, 0.2, 0.05, 1), background 0.5s cubic-bezier(0.77, 0.2, 0.05, 1), opacity 0.55s ease, -webkit-transform 0.5s cubic-bezier(0.77, 0.2, 0.05, 1)

@media screen and (max-width: 1200px)
    .container
        width 100%
@media screen and (max-width: 1200px)
    .menu
        display none
    .MobileBar
        display inline-block
    .logo
        position absolute
        left 50%
        transform translate(-50%, 0px)
        right 0
        width 2.2rem
@media (min-width: 758px) and (max-width: 946px)
    .menu
       width 78%
    .menu ul li
        font-size 14px
</style>



// WEBPACK FOOTER //
// src/pages/Layout/Header.vue